import React, { useState, useRef, useEffect, useCallback } from 'react';

import { ToolbarForm } from '../../utils/toolbar-form/ToolbarForm';


import { withLoadPanel } from '../../../utils/withLoadPanel';
import From, { Item as ItemForm, GroupItem, ColCountByScreen } from 'devextreme-react/form';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import Validator, { PatternRule, EmailRule } from 'devextreme-react/validator';
import NumberBox from 'devextreme-react/number-box';
import { ATHLETE_STATUS_LIST, GENDERS, NATIONS } from '../../../shared/constants';
import { FormPhoto } from '../../utils/form-photo/FormPhoto';
import { AthleteStatus } from '../../utils/athlete-status/AthleteStatus';
import { FormTextbox } from '../../utils/form-textbox/FormTextbox';

import ValidationGroup from 'devextreme-react/validation-group';

import './AthleteForm.scss';
import classNames from 'classnames';
import { DateBox } from 'devextreme-react';
import { FormDateBox } from '../../utils/form-datebox/FormDateBox';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { checkPermission } from '../../../permissions';

const PHOTO_SIZE = 184;

const statusRender = (text) => (
  <div className='status-editor-field'>
    <AthleteStatus text={text} showText={false} />
    <TextBox
      className={`status-athlete status-${text?.toLowerCase()}`}
      inputAttr={{ statusEditorInput: '' }}
      readOnly
      text={text}
      hoverStateEnabled={false}
    />
  </div>
);

const statusItemRender = (text) => <AthleteStatus text={text} />;

export const AthleteForm = ({ data, isLoading = false, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState(data.athlete);
  const [imageData, setImageData] = useState(data.profilePicture);
  const [dataSourceClub, setDataSourceClub] = useState();
  const [dataSourceTrainingGroup, setDataSourceTrainingGroup] = useState();
  const dataRef = useRef();
  const stylingMode = 'filled';

  useEffect(() => {
    setFormData(data.athlete);
    setImageData(data.profilePicture);
    setDataSourceClub(data.clubs);
    setDataSourceTrainingGroup(data.traininggroups);
  }, [data]);

  const onImageUploaded = useCallback((newImageData) => {
    setImageData(newImageData);
    // Auch die formData aktualisieren
    setFormData(prev => ({ ...prev, profilePicture: newImageData }));
  }, []);

  const handleEditClick = () => {
    if (editing === false && formData) {
      dataRef.current = formData;
    } else {
      dataRef.current = undefined;
    }
    setEditing(!editing);
  };

  const onSaveClick = ({ validationGroup }) => {
    if (!validationGroup.validate().isValid) return;
    handleEditClick();
    onSave(formData);
  };

  const onCancelClick = () => {
    setFormData(dataRef.current);
    handleEditClick();
  };

  const updateField = (field) => (value) => {
    if (!formData) return;
    
    setFormData({ ...formData, ...{ [field]: value } });
  };

  return (
    <div className='athlete-form'>
      <ValidationGroup>
        <ToolbarForm toggleEditing={handleEditClick} onSaveClick={onSaveClick} editing={editing} onCancelClick={onCancelClick} allowEditing={checkPermission('athlete.edit')}  />
        <From
          className={classNames({ 'plain-styled-form': true, 'view-mode': !editing })}
          labelMode='floating'
        >
          <GroupItem colCount={2}>
            <ColCountByScreen xs={2} />
            <ItemForm>
              <FormPhoto 
                link={imageData} 
                size={PHOTO_SIZE} 
                editable={editing}
                athleteId={formData?.athleteId}
                onImageUploaded={onImageUploaded}
              />
            </ItemForm>

            <GroupItem>
              <ItemForm>
                <SelectBox
                  label='Status'
                  width='100%'
                  value={formData.status}
                  readOnly={!editing}
                  items={ATHLETE_STATUS_LIST}
                  stylingMode={stylingMode}
                  fieldRender={statusRender}
                  itemRender={statusItemRender}
                  onValueChange={updateField('status')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='Vorname'
                  value={formData.surname}
                  isEditing={!editing}
                  onValueChange={updateField('surname')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='Nachname'
                  value={formData.lastname}
                  isEditing={!editing}
                  onValueChange={updateField('lastname')}
                />
              </ItemForm>
            </GroupItem>
            <ItemForm cssClass='accent' >
              <FormDateBox
                label='Geburtsdatum'
                value={formData.dateofbirth}
                readOnly={!editing}
                stylingMode={stylingMode}
                onValueChange={updateField('dateofbirth')}
              />
            </ItemForm>
            <ItemForm>
              <FormSelectBox
                label='Geschlecht'
                width='100%'
                value={formData.gender}
                readOnly={!editing}
                dataSource={GENDERS}
                valueExpr={'id'}
                displayExpr={'text'}
                showClearButton={false}
                onValueChange={updateField('gender')}
              />
            </ItemForm>
            <ItemForm>
              <FormSelectBox
                label='Trainingsgruppe'
                width='100%'
                value={formData.traininggroupId}
                readOnly={!editing}
                dataSource={dataSourceTrainingGroup}
                displayExpr='groupname'
                valueExpr='traininggroupId'
                showClearButton={true}    
                onValueChange={updateField('traininggroupId')}
              />
            </ItemForm>
            <ItemForm>
              <FormSelectBox
                label='Verein'
                width='100%'
                value={formData.clubId}
                readOnly={!editing}
                dataSource={dataSourceClub}
                displayExpr='clubname'
                valueExpr='clubId'
                showClearButton={true}
                onValueChange={updateField('clubId')}
              />
            </ItemForm>
            <ItemForm cssClass='accent' >
              <FormDateBox
                label='Eintrittsdatum'
                value={formData.entrydate}
                isEditing={!editing}
                allowClear={true}
                onValueChange={updateField('entrydate')}
              />
            </ItemForm>
            <ItemForm cssClass='accent' >
              <FormDateBox
                label='Austrittsdatum'
                value={formData.Exitdate}
                readOnly={!editing}
  allowClear={true}
                onValueChange={updateField('Exitdate')}
              />
            </ItemForm>
            <ItemForm colSpan={1}>
              <FormTextbox
                label='DSV-ID'
                value={formData.dsvId}
                isEditing={!editing}
                onValueChange={updateField('dsvId')}
              />
            </ItemForm>

            <ItemForm colSpan={1}>
              <NumberBox
                label='Klassenstufe'
                width='100%'
                value={formData.gradeLevel}
                readOnly={!editing}
                showSpinButtons={true}
                min={0}
                step={1}
                stylingMode={stylingMode}
                onValueChange={updateField('gradeLevel')}
              />
            </ItemForm>
           
             <ItemForm colSpan={1}>
              <FormSelectBox
                label='Nationalität 1'
                width='100%'
                value={formData.nation1}
                readOnly={!editing}
                dataSource={NATIONS}
                valueExpr={'id'}
                displayExpr={'text'}
                showClearButton={false}
                onValueChange={updateField('nation1')}
              />
            </ItemForm>
              <ItemForm colSpan={1}>
              <FormSelectBox
                label='Nationalität 2'
                width='100%'
                value={formData.nation2}
                readOnly={!editing}
                dataSource={NATIONS}
                valueExpr={'id'}
                displayExpr={'text'}
                showClearButton={true}
                onValueChange={updateField('nation2')}
              />
            </ItemForm>
              <ItemForm colSpan={1}>
              <FormSelectBox
                label='Nationalität 3'
                width='100%'
                value={formData.nation3}
                readOnly={!editing}
                dataSource={NATIONS}
                valueExpr={'id'}
                displayExpr={'text'}
                showClearButton={true}
                onValueChange={updateField('nation3')}
              />
            </ItemForm>
            <ItemForm cssClass='accent' >
              <FormDateBox
                label='Lizenz gültig bis'
                value={formData.lisence}
                readOnly={!editing}
                stylingMode={stylingMode}
                allowClear={false}
                showEndOfYearButton={true}
                onValueChange={updateField('lisence')}
              />
            </ItemForm>
            <ItemForm cssClass='accent' >
              <FormDateBox
                label='Med. Unt. gültig bis'
                value={formData.medicalcertificate}
                readOnly={!editing}
                stylingMode={stylingMode}
                allowClear={false}
                onValueChange={updateField('medicalcertificate')}
              />
            </ItemForm>

            {/* <ItemForm cssClass='accent' colSpan={2}>
              <FormTextbox
                label='Geburtsdatum'
                value={formData.dateofbirth}
                isEditing={!editing}
                onValueChange={updateField('dateofbirth')}
              />
            </ItemForm> */}
          </GroupItem>


        </From>
      </ValidationGroup>
    </div>
  );
};
